module.exports = __webpack_public_path__ + "static/How-Can-Subluxations-Be-Treated-and-Prevented-4f16a5fe46a2fac151a6a38d55d5214c.webp";